import React, { useEffect } from 'react';
import { Outlet, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { getUser } from '../utils/authHelper';
import { usePermissions } from '../utils/PermissionContext';

const SIDEBAR_W = 268;

const ROUTE_PERMISSIONS = {
  '/dashboard':                'dashboard',
  '/pending-requests':         'bonus.pending',
  '/completed-requests':       'bonus.completed',
  '/rejected-requests':        'bonus.rejected',
  '/settings/bonuses':         'settings.bonuses',
  '/domain-settings':          'settings.domain',
  '/site-settings':            'settings.site',
  '/blacklist-settings':       'user.blacklist',
  '/callmeblacklist-settings': 'user.callme',
  '/financial-dashboard':      'financial.dashboard',
  '/kasa-yonetimi':            'financial.kasa',
  '/gunluk-hareketler':        'financial.gunluk',
  '/odeme-yonetimi':           'financial.odeme',
  '/tahsilat-yonetimi':        'financial.tahsilat',
  '/virman-yonetimi':          'financial.virman',
  '/odeme-yontemleri':         'financial.yontemler',
  '/komisyon-hesaplama':       'financial.commission',
  '/user-management':          'user.management',
  '/verification-monitor':     'settings.verification',
};

const Layout = () => {
  const token    = localStorage.getItem('token');
  const user     = getUser();
  const location = useLocation();
  const { permissions, isSuperAdmin } = usePermissions();

  // Token veya kullanıcı yoksa login'e
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // İzin kontrolü
  const requiredPerm = ROUTE_PERMISSIONS[location.pathname];
  if (requiredPerm) {
    const ok = isSuperAdmin || permissions.includes(requiredPerm);
    if (!ok) {
      const firstAllowed = Object.entries(ROUTE_PERMISSIONS).find(([, perm]) =>
        isSuperAdmin || permissions.includes(perm)
      );
      return <Navigate to={firstAllowed?.[0] || '/login'} replace />;
    }
  }

  return (
    <LayoutInner permissions={permissions} isSuperAdmin={isSuperAdmin}>
      <Outlet />
    </LayoutInner>
  );
};

const LayoutInner = ({ children, permissions, isSuperAdmin }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const requiredPerm = ROUTE_PERMISSIONS[location.pathname];
    if (!requiredPerm) return;
    const ok = isSuperAdmin || permissions.includes(requiredPerm);
    if (!ok) {
      const firstAllowed = Object.entries(ROUTE_PERMISSIONS).find(([, perm]) =>
        isSuperAdmin || permissions.includes(perm)
      );
      navigate(firstAllowed?.[0] || '/login', { replace: true });
    }
  }, [permissions, isSuperAdmin, location.pathname, navigate]);

  return (
    <div style={{
      display: 'flex', minHeight: '100vh', background: '#090a0c',
      margin: 0, padding: 0, overflowX: 'hidden', width: '100%',
    }}>
      <Sidebar />
      <main style={{
        marginLeft: SIDEBAR_W,
        width: `calc(100% - ${SIDEBAR_W}px)`,
        minHeight: '100vh', minWidth: 0, flex: 1,
        display: 'flex', flexDirection: 'column',
        overflowX: 'hidden', background: '#090a0c', boxSizing: 'border-box',
      }}>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
